/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PreSearchDataItemStep
 */
export interface PreSearchDataItemStep {
    /**
     * 
     * @type {string}
     * @memberof PreSearchDataItemStep
     */
    stepName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreSearchDataItemStep
     */
    ruleLink?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreSearchDataItemStep
     */
    ruleDescription?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PreSearchDataItemStep
     */
    requests?: Array<string> | null;
}

export function PreSearchDataItemStepFromJSON(json: any): PreSearchDataItemStep {
    return PreSearchDataItemStepFromJSONTyped(json, false);
}

export function PreSearchDataItemStepFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreSearchDataItemStep {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stepName': !exists(json, 'stepName') ? undefined : json['stepName'],
        'ruleLink': !exists(json, 'ruleLink') ? undefined : json['ruleLink'],
        'ruleDescription': !exists(json, 'ruleDescription') ? undefined : json['ruleDescription'],
        'requests': !exists(json, 'requests') ? undefined : json['requests'],
    };
}

export function PreSearchDataItemStepToJSON(value?: PreSearchDataItemStep | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stepName': value.stepName,
        'ruleLink': value.ruleLink,
        'ruleDescription': value.ruleDescription,
        'requests': value.requests,
    };
}


